// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__SQEnL","spinner":"Loader_spinner__DydzZ","spin":"Loader_spin__I0Tfd"};